import React, { useEffect, useState } from "react";
import Popupimg from "./assets/popup.jpeg";
import "./popup.css";

function Popup() {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const popupShown = localStorage.getItem("miTradingPopupShown");

    if (!popupShown) {
      setShowPopup(true);
    }
  }, []);

  const closePopup = () => {
    setShowPopup(false);
    localStorage.setItem("miTradingPopupShown", "true");
  };

  return (
    <>
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">

            <button
              className="popup-close"
              onClick={closePopup}
            >
              ×
            </button>

            <div className="col-lg-6">
              <div className="popupimg">
                <img
                  src={Popupimg}
                  alt="MI Trading"
                />
              </div>
            </div>

          </div>
        </div>
      )}
    </>
  );
}

export default Popup;